var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_c('span',{staticClass:"ranking-num"},[_vm._v(_vm._s(_vm.rankingNum))]),_vm._v(" "+_vm._s(_vm.rankingText)+" "),_c('span',[_vm._v(_vm._s(_vm.rankingItemNum)+_vm._s(_vm.human))])])])}
var staticRenderFns = []

export { render, staticRenderFns }